import * as React from "react";
import type { SVGProps } from "react";
const SvgAddSolidIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="add_solid_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M981.333 512c0 259.2-210.133 469.333-469.333 469.333S42.667 771.2 42.667 512 252.8 42.667 512 42.667 981.333 252.8 981.333 512zM512 768a42.667 42.667 0 0 0 42.667-42.667V554.667h170.666a42.667 42.667 0 1 0 0-85.334H554.667V298.667a42.667 42.667 0 1 0-85.334 0v170.666H298.667a42.667 42.667 0 1 0 0 85.334h170.666v170.666A42.667 42.667 0 0 0 512 768z"
    />
  </svg>
);
export default SvgAddSolidIcon;
